module.exports = __webpack_public_path__ + "static/media/YashMv1.d6d7c0f9.png";